import { AvailableGlobalPermissions, AvailablePermissionsValue, RequiredPermissions } from 'features/validateAccess';

export const UPDATE_CALENDAR: RequiredPermissions = [
  [
    {
      type: 'global',
      global: AvailableGlobalPermissions.CALENDAR,
      value: AvailablePermissionsValue.UPDATE,
    },
  ],
];

export const CREATE_CALENDAR: RequiredPermissions = [
  [
    {
      type: 'global',
      global: AvailableGlobalPermissions.CALENDAR,
      value: AvailablePermissionsValue.CREATE,
    },
  ],
];
